/* DS Kids — comportamento do tema */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var moneyFormat = document.documentElement.getAttribute('data-ds-money-format') || 'R$ {{amount_with_comma_separator}}';

  /* ---------- utilidades ---------- */
  function formatMoney(cents) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      var str = (number / 100).toFixed(precision);
      var parts = str.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = moneyFormat.match(placeholder);
    var key = match ? match[1] : 'amount_with_comma_separator';
    var value;
    switch (key) {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2, '.', ',');
    }
    return moneyFormat.replace(placeholder, value);
  }

  var toastTimer;
  function toast(msg) {
    if (!msg) return;
    // Com a sacola aberta, usa o toast que vive dentro do rodapé da gaveta
    // (logo acima do Subtotal) — sem salto de posição. Fora disso, o toast fixo.
    var inCart = document.body.classList.contains('ds-cart-open');
    var el = document.getElementById(inCart ? 'DsCartToast' : 'DsToast');
    var other = document.getElementById(inCart ? 'DsToast' : 'DsCartToast');
    if (other) other.hidden = true;
    if (!el) el = document.getElementById('DsToast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = '';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 1400);
  }

  /* ---------- estoque ---------- */
  /* Limite total que cada variante pode ter na sacola. Infinity = sem limite
     (estoque não rastreado no Shopify ou venda sem estoque permitida). */
  var stockLimits = {};
  /* Quantidade que cada variante já ocupa na sacola. */
  var cartQty = {};

  function registerStock(el) {
    var data;
    try { data = JSON.parse(el.textContent); } catch (err) { return; }
    Object.keys(data).forEach(function (id) {
      stockLimits[id] = data[id] === null ? Infinity : data[id];
    });
  }

  function readCartQty(cart) {
    cartQty = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      var id = String(item.variant_id);
      cartQty[id] = (cartQty[id] || 0) + item.quantity;
    });
  }

  function stockLimit(variantId) {
    var limit = stockLimits[String(variantId)];
    return limit === undefined ? Infinity : limit;
  }

  function remainingFor(variantId) {
    var limit = stockLimit(variantId);
    if (!isFinite(limit)) return Infinity;
    return Math.max(0, limit - (cartQty[String(variantId)] || 0));
  }

  function units(n) {
    return n === 1 ? '1 unidade' : n + ' unidades';
  }

  /* Mensagem de por que não dá para adicionar (ou adicionar mais). */
  function stockMessage(variantId) {
    var limit = stockLimit(variantId);
    if (!isFinite(limit)) return '';
    if (limit <= 0) return 'Este produto está sem estoque no momento.';
    var inCart = cartQty[String(variantId)] || 0;
    var left = remainingFor(variantId);
    if (left <= 0) {
      return limit === 1
        ? 'Só temos 1 unidade e ela já está na sua sacola.'
        : 'Você já tem as ' + limit + ' unidades disponíveis na sacola.';
    }
    if (inCart > 0) {
      return 'Você já tem ' + units(inCart) + ' na sacola. Dá para adicionar mais ' + units(left) + '.';
    }
    return 'Só temos ' + units(left) + ' disponível' + (left === 1 ? '' : 'is') + '.';
  }

  /* ---------- sacola ---------- */
  function updateCounts(count) {
    document.querySelectorAll('[data-ds-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* Barra de frete grátis da página de produto (snippet benny-free-shipping-bar).
     É renderizada uma vez pelo Liquid; aqui recalculamos largura e texto a cada
     mudança na sacola (senão fica congelada até um reload). Usa a MESMA regra da
     barra do drawer: config em [data-benny-fsb-config] e base = cart.total_price. */
  function updateFreeShippingBar(cart) {
    if (!cart) return;
    var bar = document.querySelector('[data-benny-free-shipping-bar]');
    if (!bar) return;

    var cfgEl = document.querySelector('[data-benny-fsb-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { return; }
    var threshold = parseInt(cfg.threshold, 10);
    if (!threshold || threshold <= 0) return;

    var total = cart.total_price;
    var pct = Math.min(100, total * 100 / threshold);

    var fill = bar.querySelector('[data-benny-fsb-fill]');
    if (fill) fill.style.width = pct + '%';

    var textEl = bar.querySelector('[data-benny-fsb-text]');
    if (textEl) {
      if (total >= threshold) {
        textEl.textContent = cfg.reached || '';
      } else {
        textEl.textContent = String(cfg.missing || '').replace('[valor]', formatMoney(threshold - total));
      }
    }
  }

  function openCart() {
    document.body.classList.add('ds-cart-open');
  }
  function closeCart() {
    document.body.classList.remove('ds-cart-open');
  }

  function refreshCart(open) {
    return Promise.all([
      fetch(root + 'cart.js').then(function (r) { return r.json(); }),
      fetch(root + '?sections=ds-cart-drawer').then(function (r) { return r.json(); })
    ]).then(function (results) {
      var cart = results[0];
      var sections = results[1];
      updateCounts(cart.item_count);
      readCartQty(cart);
      syncStockUI();
      var current = document.getElementById('shopify-section-ds-cart-drawer');
      if (current && sections['ds-cart-drawer']) {
        var tpl = document.createElement('div');
        tpl.innerHTML = sections['ds-cart-drawer'];
        var fresh = tpl.firstElementChild;
        if (fresh) current.replaceWith(fresh);
      }
      updateFreeShippingBar(cart);
      if (open) openCart();
      return cart;
    });
  }

  function addToCart(body, successMsg) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: body
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          toast(data.description || data.message || 'Não foi possível adicionar.');
          throw new Error(data.description || 'add-error');
        }
        var autoOpen = document.body.classList.contains('ds-cart-auto-open');
        toast(successMsg || document.body.getAttribute('data-ds-added-msg') || '✓ Adicionado à sacola');
        return refreshCart(autoOpen);
      });
    });
  }

  function changeLine(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { return refreshCart(false); });
  }

  window.dsCart = { open: openCart, close: closeCart, refresh: refreshCart, add: addToCart, change: changeLine };
  window.dsToast = toast;

  /* ---------- modais (tabela de medidas, parcelamento) ---------- */
  var modalTrigger = null;
  function closeModals() {
    document.querySelectorAll('[data-ds-modal]').forEach(function (m) { m.hidden = true; });
    document.body.classList.remove('ds-modal-open');
    if (modalTrigger) {
      modalTrigger.focus();
      modalTrigger = null;
    }
  }

  /* ---------- parcelamento ---------- */
  function installmentTotal(price, rate) {
    return Math.round(price * (100 + rate) / 100);
  }

  function updateInstallments(container, price) {
    var inline = container.querySelector('[data-ds-installments]');
    if (inline) {
      var n = parseInt(inline.getAttribute('data-count'), 10) || 4;
      var rate = parseFloat(inline.getAttribute('data-rate')) || 0;
      var each = Math.floor(installmentTotal(price, rate) / n);
      inline.textContent = n + 'x de ' + formatMoney(each) + (rate === 0 ? ' ' + (inline.getAttribute('data-suffix') || '') : '');
    }
    container.querySelectorAll('[data-ds-inst-row]').forEach(function (row) {
      var rowN = parseInt(row.getAttribute('data-n'), 10) || 1;
      var rowRate = parseFloat(row.getAttribute('data-rate')) || 0;
      var total = installmentTotal(price, rowRate);
      var labelEl = row.querySelector('[data-ds-inst-label]');
      var totalEl = row.querySelector('[data-ds-inst-total]');
      if (rowN === 1) {
        if (totalEl) totalEl.textContent = formatMoney(total);
        return;
      }
      if (labelEl) {
        labelEl.textContent = rowN + 'x de ' + formatMoney(Math.floor(total / rowN)) + (rowRate === 0 ? ' sem juros' : '');
      }
      if (totalEl) totalEl.textContent = 'Total: ' + formatMoney(total);
    });
    container.querySelectorAll('[data-ds-inst-cash]').forEach(function (el) {
      var discount = parseFloat(el.getAttribute('data-discount')) || 0;
      el.textContent = formatMoney(Math.round(price * (100 - discount) / 100));
    });
  }

  /* ---------- cliques delegados ---------- */
  document.addEventListener('click', function (e) {
    var t;

    if ((t = e.target.closest('[data-ds-open-cart]'))) {
      e.preventDefault();
      openCart();
      return;
    }
    if ((t = e.target.closest('[data-ds-close-cart]'))) {
      // Se for um link real (ex.: "Ver catálogo" da sacola vazia), não cancela
      // a navegação — só fecha a gaveta e deixa o browser seguir o href.
      var isLink = t.tagName === 'A' && t.getAttribute('href') && t.getAttribute('href') !== '#';
      if (!isLink) e.preventDefault();
      closeCart();
      return;
    }
    if ((t = e.target.closest('[data-ds-open-search]'))) {
      e.preventDefault();
      var modal = document.getElementById('DsSearchModal');
      if (modal) {
        modal.classList.add('is-open');
        var input = modal.querySelector('input[name="q"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
      return;
    }
    if ((t = e.target.closest('[data-ds-close-search]'))) {
      e.preventDefault();
      var m = document.getElementById('DsSearchModal');
      if (m) m.classList.remove('is-open');
      return;
    }
    if ((t = e.target.closest('[data-ds-quick-add]'))) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = t.getAttribute('data-variant-id');
      var url = t.getAttribute('data-url');
      if (variantId) {
        if (remainingFor(variantId) <= 0) {
          toast(stockMessage(variantId));
          return;
        }
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        t.disabled = true;
        addToCart(fd).catch(function () {}).finally(function () { t.disabled = false; });
      } else if (url) {
        window.location.href = url;
      }
      return;
    }
    if ((t = e.target.closest('[data-ds-quick-open]'))) {
      e.preventDefault();
      e.stopPropagation();
      var card = t.closest('.ds-card');
      var modal = card && card.querySelector('[data-ds-quick-modal]');
      if (modal) {
        modal.hidden = false;
        document.body.classList.add('ds-quick-open');
      }
      return;
    }
    if ((t = e.target.closest('[data-ds-quick-close]'))) {
      e.preventDefault();
      var quickModalToClose = t.closest('[data-ds-quick-modal]');
      if (quickModalToClose) quickModalToClose.hidden = true;
      document.body.classList.remove('ds-quick-open');
      return;
    }
    if ((t = e.target.closest('[data-ds-quick-submit]'))) {
      e.preventDefault();
      if (t.disabled) return;
      var quickVariantId = t.getAttribute('data-variant-id');
      if (!quickVariantId) return;
      if (remainingFor(quickVariantId) <= 0) {
        toast(stockMessage(quickVariantId));
        return;
      }
      var quickFd = new FormData();
      quickFd.append('id', quickVariantId);
      quickFd.append('quantity', '1');
      t.disabled = true;
      addToCart(quickFd).then(function () {
        var quickModalToSubmit = t.closest('[data-ds-quick-modal]');
        if (quickModalToSubmit) quickModalToSubmit.hidden = true;
        document.body.classList.remove('ds-quick-open');
      }).catch(function () {}).finally(function () { t.disabled = false; });
      return;
    }
    if ((t = e.target.closest('[data-ds-modal-open]'))) {
      e.preventDefault();
      var modalRoot = t.closest('[data-ds-modal-root]');
      var dsModal = modalRoot && modalRoot.querySelector('[data-ds-modal]');
      if (dsModal) {
        modalTrigger = t;
        dsModal.hidden = false;
        document.body.classList.add('ds-modal-open');
        var modalClose = dsModal.querySelector('button[data-ds-modal-close]');
        if (modalClose) modalClose.focus();
      }
      return;
    }
    if ((t = e.target.closest('[data-ds-modal-close]'))) {
      e.preventDefault();
      closeModals();
      return;
    }
    if ((t = e.target.closest('[data-ds-inst-tab]'))) {
      e.preventDefault();
      var instRoot = t.closest('[data-ds-inst-root]');
      var instTarget = t.getAttribute('data-ds-inst-tab');
      if (instRoot) {
        instRoot.querySelectorAll('[data-ds-inst-tab]').forEach(function (tab) {
          var isActive = tab === t;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        instRoot.querySelectorAll('[data-ds-inst-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-ds-inst-panel') !== instTarget;
        });
      }
      return;
    }
    if ((t = e.target.closest('[data-ds-line-remove]'))) {
      e.preventDefault();
      changeLine(parseInt(t.getAttribute('data-line'), 10), 0);
      return;
    }
    if ((t = e.target.closest('[data-ds-line-change]'))) {
      e.preventDefault();
      changeLine(parseInt(t.getAttribute('data-line'), 10), parseInt(t.getAttribute('data-qty'), 10));
      return;
    }
    if ((t = e.target.closest('[data-ds-qty-dec]'))) {
      var inpDec = t.parentElement.querySelector('input');
      if (inpDec) inpDec.value = Math.max(1, parseInt(inpDec.value || '1', 10) - 1);
      return;
    }
    if ((t = e.target.closest('[data-ds-qty-inc]'))) {
      var inpInc = t.parentElement.querySelector('input');
      if (inpInc) {
        var next = parseInt(inpInc.value || '1', 10) + 1;
        var incMax = parseInt(inpInc.getAttribute('max'), 10);
        if (!isNaN(incMax) && next > incMax) {
          next = incMax;
          var incForm = t.closest('form');
          var incId = incForm && incForm.querySelector('[data-ds-variant-id]');
          toast(incId ? stockMessage(incId.value) : 'Quantidade máxima disponível.');
        }
        inpInc.value = next;
      }
      return;
    }
    if ((t = e.target.closest('[data-ds-thumb]'))) {
      e.preventDefault();
      var gallery = t.closest('[data-ds-gallery]');
      selectThumb(gallery, t);
      return;
    }
    if ((t = e.target.closest('[data-ds-nav]'))) {
      e.preventDefault();
      var navGallery = t.closest('[data-ds-gallery]');
      stepGallery(navGallery, t.getAttribute('data-ds-nav') === 'next' ? 1 : -1);
      return;
    }
  });

  function selectThumb(gallery, thumb) {
    var main = gallery && gallery.querySelector('[data-ds-main-image]');
    if (!main) return;
    main.src = thumb.getAttribute('data-src');
    if (thumb.getAttribute('data-srcset')) main.srcset = thumb.getAttribute('data-srcset');
    gallery.querySelectorAll('[data-ds-thumb]').forEach(function (th) { th.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  function stepGallery(gallery, direction) {
    if (!gallery) return;
    var thumbs = gallery.querySelectorAll('[data-ds-thumb]');
    if (thumbs.length < 2) return;
    var currentIndex = 0;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active')) { currentIndex = i; break; }
    }
    var nextIndex = (currentIndex + direction + thumbs.length) % thumbs.length;
    selectThumb(gallery, thumbs[nextIndex]);
  }

  /* ---------- galeria de produto: swipe/drag na foto principal ---------- */
  document.addEventListener('pointerdown', function (e) {
    var media = e.target.closest('.ds-product__media');
    if (!media || e.target.closest('[data-ds-nav], .ds-product__back')) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;

    var gallery = media.closest('[data-ds-gallery]');
    if (!gallery || gallery.querySelectorAll('[data-ds-thumb]').length < 2) return;

    var startX = e.clientX;
    var startY = e.clientY;
    var dragging = false;

    function move(ev) {
      var dx = ev.clientX - startX;
      var dy = ev.clientY - startY;
      if (!dragging && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) dragging = true;
      if (dragging) ev.preventDefault();
    }

    function up(ev) {
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', up);
      document.removeEventListener('pointercancel', up);
      var dx = ev.clientX - startX;
      if (dragging) {
        if (Math.abs(dx) > 40) stepGallery(gallery, dx < 0 ? 1 : -1);
      } else if (e.pointerType === 'mouse') {
        var rect = media.getBoundingClientRect();
        var clickedRight = ev.clientX - rect.left > rect.width / 2;
        stepGallery(gallery, clickedRight ? 1 : -1);
      }
    }

    document.addEventListener('pointermove', move);
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      var m = document.getElementById('DsSearchModal');
      if (m) m.classList.remove('is-open');
      document.querySelectorAll('[data-ds-quick-modal]').forEach(function (qm) { qm.hidden = true; });
      document.body.classList.remove('ds-quick-open');
      closeModals();
    }
  });

  /* ---------- formulário de produto ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ds-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-ds-buy-btn]');
    if (btn && btn.disabled) return;

    var idInput = form.querySelector('[data-ds-variant-id]');
    var variantId = idInput ? idInput.value : '';
    var qtyInput = form.querySelector('input[name="quantity"]');
    var wanted = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
    if (isNaN(wanted) || wanted < 1) wanted = 1;

    var left = remainingFor(variantId);
    if (left <= 0) {
      toast(stockMessage(variantId));
      return;
    }

    /* Nunca envia mais do que sobra em estoque: corta e avisa no fim. */
    var successMsg;
    if (wanted > left) {
      successMsg = 'Adicionamos ' + units(left) + ' — é o máximo disponível.';
      wanted = left;
    }
    if (qtyInput) qtyInput.value = wanted;

    if (btn) btn.disabled = true;
    addToCart(new FormData(form), successMsg).catch(function () {}).finally(function () {
      if (btn) btn.disabled = false;
      refreshFormState(form.closest('[data-ds-variant-picker-root]') || form);
    });
  });

  /* Digitação direta no campo de quantidade */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.ds-qty input[name="quantity"]')) return;
    var value = parseInt(input.value || '1', 10);
    if (isNaN(value) || value < 1) value = 1;
    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && value > max) {
      value = Math.max(1, max);
      var form = input.closest('form');
      var idInput = form && form.querySelector('[data-ds-variant-id]');
      toast(idInput ? stockMessage(idInput.value) : 'Quantidade máxima disponível.');
    }
    input.value = value;
  });

  /* ---------- estoque na interface ---------- */
  /* Ajusta o campo de quantidade e o botão de comprar ao que ainda cabe na
     sacola. Só reabilita o botão quando a variante em si está disponível —
     variante esgotada continua sendo responsabilidade do seletor. */
  function refreshFormState(container) {
    if (!container) return;
    var idInput = container.querySelector('[data-ds-variant-id]');
    if (!idInput) return;
    var variantId = idInput.value;
    var limit = stockLimit(variantId);
    var left = remainingFor(variantId);
    var input = container.querySelector('.ds-qty input[name="quantity"]');
    var btn = container.querySelector('[data-ds-buy-btn]');

    /* Sem seletor de variantes inicializado, o estado do servidor manda. */
    if (container.dsVariantUnavailable === undefined) {
      container.dsVariantUnavailable = btn ? btn.disabled : false;
    }

    if (input) {
      if (isFinite(limit)) {
        input.setAttribute('max', String(Math.max(1, left)));
        if (parseInt(input.value || '1', 10) > left) input.value = Math.max(1, left);
      } else {
        input.removeAttribute('max');
      }
    }

    if (!btn || container.dsVariantUnavailable) return;
    if (isFinite(limit) && left <= 0) {
      btn.disabled = true;
      btn.textContent = limit <= 0 ? 'Esgotado' : 'Máximo na sacola';
    } else {
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-label') || 'Adicionar à sacola';
    }
  }

  function refreshQuickState(modal) {
    var btn = modal.querySelector('[data-ds-quick-submit]');
    if (!btn || modal.dsVariantUnavailable) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var limit = stockLimit(variantId);
    if (isFinite(limit) && remainingFor(variantId) <= 0) {
      btn.disabled = true;
      btn.textContent = limit <= 0 ? 'Esgotado' : 'Máximo na sacola';
    } else {
      btn.disabled = false;
      btn.textContent = 'Adicionar à sacola';
    }
  }

  function syncStockUI() {
    document.querySelectorAll('[data-ds-variant-picker-root]').forEach(refreshFormState);
    document.querySelectorAll('[data-ds-quick-modal]').forEach(refreshQuickState);
    document.querySelectorAll('[data-ds-quick-add][data-variant-id]').forEach(function (btn) {
      var limit = stockLimit(btn.getAttribute('data-variant-id'));
      if (!isFinite(limit)) return;
      btn.disabled = remainingFor(btn.getAttribute('data-variant-id')) <= 0;
    });
  }

  /* Marca cada pill de opção como indisponível quando não existe nenhuma
     variante em estoque combinando esse valor com o que já está selecionado
     nas outras opções (ex.: cor Rosé + tamanho 3 esgotado). */
  function updateOptionAvailability(root, variants, opts) {
    root.querySelectorAll('[data-ds-option-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-ds-option-index'), 10);
      group.querySelectorAll('.ds-pill').forEach(function (pill) {
        var input = pill.querySelector('input');
        if (!input) return;
        var available = variants.some(function (v) {
          return v.available && v.options[idx] === input.value && v.options.every(function (opt, j) {
            return j === idx || opts[j] == null || opt === opts[j];
          });
        });
        pill.classList.toggle('is-unavailable', !available);
      });
    });
  }

  /* ---------- seletor de variantes ---------- */
  function initVariantPicker(container) {
    var jsonEl = container.querySelector('[data-ds-variants-json]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    function currentOptions() {
      var opts = [];
      container.querySelectorAll('[data-ds-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts[parseInt(group.getAttribute('data-ds-option-index'), 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function onChange() {
      var opts = currentOptions();
      updateOptionAvailability(container, variants, opts);
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opts[i] === null || opt === opts[i]; });
      });
      var idInput = container.querySelector('[data-ds-variant-id]');
      var btn = container.querySelector('[data-ds-buy-btn]');
      var priceEl = container.querySelector('[data-ds-price]');
      var oldEl = container.querySelector('[data-ds-old-price]');

      if (!variant) {
        container.dsVariantUnavailable = true;
        if (btn) { btn.disabled = true; btn.textContent = 'Indisponível'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (oldEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          oldEl.textContent = formatMoney(variant.compare_at_price);
          oldEl.hidden = false;
        } else {
          oldEl.hidden = true;
        }
      }
      updateInstallments(container, variant.price);
      container.dsVariantUnavailable = !variant.available;
      if (btn && !variant.available) {
        btn.disabled = true;
        btn.textContent = 'Esgotado';
      }
      refreshFormState(container);
      var media = variant.featured_image;
      if (media && media.src) {
        var main = container.closest('[data-ds-product]');
        var img = main && main.querySelector('[data-ds-main-image]');
        if (img) { img.src = media.src; img.removeAttribute('srcset'); }
      }
    }

    container.addEventListener('change', function (e) {
      if (e.target.matches('[data-ds-option-index] input')) onChange();
    });

    /* Estado inicial vem do servidor; aqui só aplicamos o limite de estoque. */
    var initialBtn = container.querySelector('[data-ds-buy-btn]');
    container.dsVariantUnavailable = initialBtn ? initialBtn.disabled : false;
    updateOptionAvailability(container, variants, currentOptions());
    refreshFormState(container);
  }

  /* ---------- seletor rápido (cartão de produto) ---------- */
  function initQuickModal(modal) {
    var jsonEl = modal.querySelector('[data-ds-quick-variants]');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    function currentOptions() {
      var opts = [];
      modal.querySelectorAll('[data-ds-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts[parseInt(group.getAttribute('data-ds-option-index'), 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function onChange() {
      var opts = currentOptions();
      updateOptionAvailability(modal, variants, opts);
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opts[i] == null || opt === opts[i]; });
      });
      var btn = modal.querySelector('[data-ds-quick-submit]');
      var priceEl = modal.querySelector('[data-ds-quick-price]');

      if (!variant) {
        modal.dsVariantUnavailable = true;
        if (btn) {
          btn.disabled = true;
          btn.removeAttribute('data-variant-id');
          btn.textContent = 'Selecione uma opção';
        }
        return;
      }
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      modal.dsVariantUnavailable = !variant.available;
      if (btn) {
        btn.setAttribute('data-variant-id', variant.id);
        if (!variant.available) {
          btn.disabled = true;
          btn.textContent = 'Esgotado';
        }
      }
      refreshQuickState(modal);
    }

    modal.addEventListener('change', function (e) {
      if (e.target.matches('[data-ds-option-index] input')) onChange();
    });

    onChange();
  }

  /* ---------- recomendações de produto ---------- */
  function initRecommendations(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tpl = document.createElement('div');
      tpl.innerHTML = html;
      var inner = tpl.querySelector('[data-ds-recommendations-inner]');
      if (inner && inner.children.length > 0) {
        el.innerHTML = inner.outerHTML;
        el.querySelectorAll('[data-ds-stock-json]').forEach(registerStock);
        el.querySelectorAll('[data-ds-quick-modal]').forEach(initQuickModal);
        syncStockUI();
      }
    }).catch(function () {});
  }

  /* ---------- filtro de tamanho (slider de dois cabos) ---------- */
  var DS_SIZE_SCALE = ['RN', 'P', 'M', 'G', 'GG', '1', '2', '3', '4', '6', '8', '10', '12', '14', '16'];

  function formatSizeLabel(sizeValue) {
    if (/^\d+$/.test(sizeValue)) {
      return sizeValue + (sizeValue === '1' ? ' ano' : ' anos');
    }
    return sizeValue;
  }

  function initSizeFilter(filterEl) {
    var grid = document.querySelector('[data-ds-product-grid]');

    var track = filterEl.querySelector('.ds-size-filter__track-wrap');
    var range = filterEl.querySelector('[data-ds-size-range]');
    var valueLabel = filterEl.querySelector('[data-ds-size-value]');
    var minHandle = filterEl.querySelector('[data-ds-size-handle="min"]');
    var maxHandle = filterEl.querySelector('[data-ds-size-handle="max"]');
    var stockToggle = filterEl.parentElement && filterEl.parentElement.querySelector('[data-ds-stock-toggle]');
    if (!track || !range || !minHandle || !maxHandle) return;

    var scaleMin = parseInt(filterEl.getAttribute('data-min-index'), 10);
    var scaleMax = parseInt(filterEl.getAttribute('data-max-index'), 10);
    if (isNaN(scaleMin) || isNaN(scaleMax) || scaleMax <= scaleMin) return;

    // Parâmetro nativo do Storefront Filtering (ex.: "filter.v.option.tamanho").
    var sizeParam = filterEl.getAttribute('data-ds-size-param') || 'filter.v.option.tamanho';
    var stockParam = filterEl.getAttribute('data-ds-stock-param') || 'filter.v.availability';

    // Valores discretos que a coleção realmente tem: [{ value, index, count }].
    var sizeValues = [];
    try {
      sizeValues = JSON.parse(filterEl.getAttribute('data-ds-size-values') || '[]');
    } catch (err) {
      sizeValues = [];
    }
    var availableIndexes = sizeValues.map(function (v) { return v.index; });

    // Estado inicial dos cabos: vem do Liquid (data-handle-*), que já reflete o
    // filtro aplicado via collection.filters. Fallback para as pontas da escala.
    var currentMin = parseInt(filterEl.getAttribute('data-handle-min-index'), 10);
    var currentMax = parseInt(filterEl.getAttribute('data-handle-max-index'), 10);
    if (isNaN(currentMin) || currentMin < scaleMin || currentMin > scaleMax) currentMin = scaleMin;
    if (isNaN(currentMax) || currentMax < scaleMin || currentMax > scaleMax) currentMax = scaleMax;
    if (currentMax < currentMin) { currentMin = scaleMin; currentMax = scaleMax; }

    function indexToPercent(index) {
      return ((index - scaleMin) / (scaleMax - scaleMin)) * 100;
    }

    function render() {
      var minPct = indexToPercent(currentMin);
      var maxPct = indexToPercent(currentMax);
      minHandle.style.left = minPct + '%';
      maxHandle.style.left = maxPct + '%';
      range.style.left = minPct + '%';
      range.style.right = (100 - maxPct) + '%';
      minHandle.setAttribute('aria-valuetext', formatSizeLabel(DS_SIZE_SCALE[currentMin]));
      maxHandle.setAttribute('aria-valuetext', formatSizeLabel(DS_SIZE_SCALE[currentMax]));
      if (valueLabel) {
        valueLabel.textContent = formatSizeLabel(DS_SIZE_SCALE[currentMin]) + ' – ' + formatSizeLabel(DS_SIZE_SCALE[currentMax]);
      }
    }

    function flashGrid() {
      if (!grid) return;
      grid.classList.remove('is-flash');
      // Force reflow so re-adding the class restarts the animation.
      void grid.offsetWidth;
      grid.classList.add('is-flash');
      clearTimeout(grid._dsFlashTimeout);
      grid._dsFlashTimeout = setTimeout(function () {
        grid.classList.remove('is-flash');
      }, 260);
    }

    // Traduz o intervalo dos cabos em parâmetros de filtro nativo e recarrega a
    // página (mesmo padrão da ordenação). O servidor filtra e pagina a coleção
    // inteira — sem esconder cards no cliente. Debounce de 350ms para não
    // disparar um reload por tecla ao usar as setas do teclado.
    var submitTimer = null;
    function submitSizeFilter(immediate) {
      if (submitTimer) clearTimeout(submitTimer);
      if (immediate) { doSubmit(); return; }
      submitTimer = setTimeout(doSubmit, 350);
    }

    function doSubmit() {
      var params = new URLSearchParams(window.location.search);

      // Só os valores que existem na coleção E caem dentro do intervalo.
      var picked = sizeValues.filter(function (v) {
        return v.index >= currentMin && v.index <= currentMax;
      }).map(function (v) { return String(v.value); });

      // Intervalo cobre todos os tamanhos existentes -> sem filtro (URL limpa).
      var coversAll = availableIndexes.length > 0 && availableIndexes.every(function (i) {
        return i >= currentMin && i <= currentMax;
      });

      params.delete(sizeParam);
      if (!coversAll && picked.length) {
        picked.forEach(function (val) { params.append(sizeParam, val); });
      }

      if (stockToggle && stockToggle.checked) {
        params.set(stockParam, '1');
      } else {
        params.delete(stockParam);
      }

      params.delete('page');

      var qs = params.toString();
      var next = window.location.pathname + (qs ? '?' + qs : '');
      // Nada mudou -> não recarrega à toa.
      if (next === window.location.pathname + window.location.search) return;
      window.location.assign(next);
    }

    function positionToIndex(clientX) {
      var rect = track.getBoundingClientRect();
      var pct = (clientX - rect.left) / rect.width;
      pct = Math.max(0, Math.min(1, pct));
      var rawIndex = scaleMin + pct * (scaleMax - scaleMin);
      return Math.round(rawIndex);
    }

    function startDrag(which) {
      return function (e) {
        e.preventDefault();
        var handle = which === 'min' ? minHandle : maxHandle;
        handle.setPointerCapture && e.pointerId != null && handle.setPointerCapture(e.pointerId);

        function move(ev) {
          var index = positionToIndex(ev.clientX);
          if (which === 'min') {
            currentMin = Math.min(index, currentMax);
          } else {
            currentMax = Math.max(index, currentMin);
          }
          render();
        }

        function up() {
          document.removeEventListener('pointermove', move);
          document.removeEventListener('pointerup', up);
          document.removeEventListener('pointercancel', up);
          flashGrid();
          submitSizeFilter(true);
        }

        document.addEventListener('pointermove', move);
        document.addEventListener('pointerup', up);
        document.addEventListener('pointercancel', up);
      };
    }

    minHandle.addEventListener('pointerdown', startDrag('min'));
    maxHandle.addEventListener('pointerdown', startDrag('max'));

    function step(handle, delta) {
      if (handle === minHandle) {
        currentMin = Math.max(scaleMin, Math.min(currentMax, currentMin + delta));
      } else {
        currentMax = Math.min(scaleMax, Math.max(currentMin, currentMax + delta));
      }
      render();
      flashGrid();
      submitSizeFilter();
    }

    [minHandle, maxHandle].forEach(function (handle) {
      handle.setAttribute('role', 'slider');
      handle.setAttribute('tabindex', '0');
      handle.setAttribute('aria-valuemin', formatSizeLabel(DS_SIZE_SCALE[scaleMin]));
      handle.setAttribute('aria-valuemax', formatSizeLabel(DS_SIZE_SCALE[scaleMax]));
      handle.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); step(handle, 1); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); step(handle, -1); }
      });
    });

    if (stockToggle) {
      stockToggle.addEventListener('change', function () {
        flashGrid();
        submitSizeFilter(true);
      });
    }

    render();
  }

  /* ---------- barra de anúncios (rotação) ---------- */
  function initAnnouncement(bar) {
    var items = bar.querySelectorAll('.ds-announcement__item');
    var delay = parseInt(bar.getAttribute('data-rotate'), 10);
    if (items.length < 2 || !delay) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, delay * 1000);
  }

  /* ---------- comparador antes/depois ---------- */
  document.addEventListener('input', function (e) {
    if (e.target.matches('.ds-compare__range')) {
      var media = e.target.closest('[data-ds-compare]');
      if (media) media.style.setProperty('--compare', e.target.value);
    }
  });

  document.addEventListener('pointerdown', function (e) {
    var media = e.target.closest('[data-ds-compare]');
    if (!media) return;
    e.preventDefault();
    var rect = media.getBoundingClientRect();
    var range = media.querySelector('.ds-compare__range');
    function setFrom(clientX) {
      var pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
      media.style.setProperty('--compare', pct);
      if (range) range.value = Math.round(pct);
    }
    setFrom(e.clientX);
    function move(ev) { setFrom(ev.clientX); }
    function up() {
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', up);
      document.removeEventListener('pointercancel', up);
    }
    document.addEventListener('pointermove', move);
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
  });

  /* ---------- ordenação da coleção ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-ds-sort]')) {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', e.target.value);
      window.location.search = params.toString();
    }
  });

  /* ---------- inicialização ---------- */
  function init() {
    document.querySelectorAll('[data-ds-stock-json]').forEach(registerStock);
    document.querySelectorAll('[data-ds-variant-picker-root]').forEach(initVariantPicker);
    document.querySelectorAll('[data-ds-quick-modal]').forEach(initQuickModal);
    document.querySelectorAll('[data-ds-recommendations]').forEach(initRecommendations);
    document.querySelectorAll('.ds-announcement[data-rotate]').forEach(initAnnouncement);
    document.querySelectorAll('[data-ds-size-filter]').forEach(initSizeFilter);
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCounts(cart.item_count);
      readCartQty(cart);
      syncStockUI();
      updateFreeShippingBar(cart);
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Suporte ao editor de temas */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ds-stock-json]').forEach(registerStock);
    e.target.querySelectorAll('[data-ds-variant-picker-root]').forEach(initVariantPicker);
    e.target.querySelectorAll('[data-ds-quick-modal]').forEach(initQuickModal);
    e.target.querySelectorAll('[data-ds-recommendations]').forEach(initRecommendations);
    e.target.querySelectorAll('.ds-announcement[data-rotate]').forEach(initAnnouncement);
    syncStockUI();
  });
})();
